import type { GlossaryEntry } from "@/types/glossary";

// Dynamic import of all glossary JSON files
const dataModules = import.meta.glob<{ default: GlossaryEntry }>(
  "/src/data/glossary/*.json",
  { eager: true }
);

// Dynamic import of all glossary Markdown content
const contentModules = import.meta.glob<string>(
  "/src/content/glossary/*.md",
  { eager: true, query: "?raw", import: "default" }
);

// Build lookup maps
export const glossaryData: Record<string, GlossaryEntry> = {};
export const glossaryContent: Record<string, string> = {};

// Parse JSON modules
for (const path in dataModules) {
  const match = path.match(/\/([^/]+)\.json$/);
  if (match) {
    const termId = match[1];
    glossaryData[termId] = dataModules[path].default;
  }
}

// Parse Markdown modules
for (const path in contentModules) {
  const match = path.match(/\/([^/]+)\.md$/);
  if (match) {
    const termId = match[1];
    glossaryContent[termId] = contentModules[path];
  }
}

// Get all entries sorted alphabetically by term
export const getGlossaryList = (): GlossaryEntry[] => {
  return Object.values(glossaryData).sort((a, b) =>
    a.term.localeCompare(b.term, "de")
  );
};

// Get slugs for SSG
export const getGlossarySlugs = (): string[] => {
  return Object.keys(glossaryData);
};

// Get content for a specific term (for full-text search)
export const getGlossaryContentById = (termId: string): string | undefined => {
  return glossaryContent[termId];
};

// Get all entries with their content for full-text search
export const getGlossaryListWithContent = (): Array<GlossaryEntry & { content?: string }> => {
  return Object.values(glossaryData)
    .map((entry) => ({
      ...entry,
      content: glossaryContent[entry.termId] || "",
    }))
    .sort((a, b) => a.term.localeCompare(b.term, "de"));
};
